import React from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const ChannelTypeFilterComponent = ({
  value,
  onChange,
  options,
  classes,
  paddingAvailable = false,
  company
}) => {
  //   const classes = useStyles();

  console.log("CheckingCompany",company);
  

  return (
    <Grid item xs={12} container component={Paper} spacing={2}>
      <Grid
        item
        xs={12}
        sm={12}
        style={paddingAvailable ? {} : { paddingTop: 0 }}
      >
        <FormControl fullWidth className={classes.formControl}>
          <InputLabel
            className={classes.filterLabel}
            style={{ color: !value.includes("All") ? "#4472c4" : "#000" }}
            id="select-region-label"
          >
            {company === 'C0023' ? 'Deal' : 'Channel '} Type:
          </InputLabel>
          <Select
            data-test="Channel_Type__c"
            value={value}
            onChange={onChange}
            name="Channel_Type__c"
            multiple
          >
            <MenuItem value={"All"}>All</MenuItem>
            {options &&
              options.map((item) => (
                <MenuItem
                  key={item.Channel_Type__c}
                  value={item.Channel_Type__c}
                >
                  {item.Channel_Type__c}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default ChannelTypeFilterComponent;
